/* Exact legacy WordPress routing. No authentication, pricing or cart behavior. */
(() => {
  const url = new URL(window.location.href);
  const path = url.pathname.replace(/\/+$/, '') || '/';
  if (url.searchParams.has('view') || url.searchParams.has('preview_theme_id')) return;
  let target;
  if (path === '/shop') {
    target = '/collections/all';
  } else if (path === '/') {
    const known = {
    "page_id=9701": "/policies/terms-of-service",
    "page_id=2": "/",
    "page_id=3947": "/popup-test/",
    "page_id=7349": "/get-texts-for-exclusive-deals/",
    "page_id=6379": "/bob-test/",
    "page_id=5452": "/policies/shipping-policy",
    "page_id=4598": "/pages/josefs-ham-salad",
    "page_id=4398": "/blogs/journal",
    "page_id=4009": "/pages/awards",
    "page_id=3898": "/happy-to-see-you/",
    "page_id=3106": "/pages/holiday-schedule",
    "page_id=3000": "/policies/privacy-policy",
    "page_id=2652": "/pages/kase-krainer-corn-dogs",
    "page_id=2647": "/pages/stuffed-chicken-breast-with-apricot-cranberry-sausage-stuffing",
    "page_id=2641": "/pages/egg-canadian-bacon-pastry-cups",
    "page_id=2636": "/pages/bacon-chocolate-chip-cookies",
    "page_id=2630": "/pages/bangers-and-mash-with-onion-gravy",
    "page_id=2624": "/pages/oktoberfest-potato-salad",
    "page_id=2616": "/pages/brats-n-beer-sauce",
    "page_id=2608": "/pages/black-forest-ham-pizza",
    "page_id=2600": "/pages/apple-sausage-salad-with-poppy-seed-dressing",
    "page_id=2593": "/pages/sweet-spicy-andouille-bites",
    "page_id=2589": "/pages/recipes",
    "page_id=2487": "/pages/faqs",
    "page_id=2477": "/pages/our-guarantee",
    "page_id=2469": "/pages/ordering-shipping",
    "page_id=1894": "/pages/josefs-story",
    "page_id=13": "/pages/about-us",
    "page_id=11": "/pages/contact-us",
    "p=8509": "/blogs/journal/josefs-for-national-swiss-is-a-cant-miss",
    "p=4604": "/blogs/journal/hamtastic-ways-to-use-leftover-ham",
    "p=7357": "/blogs/journal/recipes-with-bacon",
    "p=6123": "/blogs/journal/law-of-the-land-our-landjager-salami",
    "p=5880": "/blogs/journal/getting-the-knack-the-complete-guide-to-knackwurst-sausage",
    "p=5723": "/blogs/journal/all-about-andouille",
    "p=5385": "/blogs/journal/our-wildcard-match-chicken-supremo-smoked-chorizo",
    "p=5285": "/blogs/journal/battle-of-the-brats-frankfurter-smoked-andouille-showdown",
    "p=5004": "/blogs/journal/german-bratwurst-and-jalapeno-cheddar-bratwurst-classic-vs-rock-star",
    "p=4815": "/blogs/journal/the-sweet-taste-of-victory-josefs-award-winning-meats",
    "p=4403": "/blogs/journal/bangers-mash-what-the-heck-is-that"
};
    const keys = ['page_id', 'p'].filter((key) => url.searchParams.has(key));
    if (keys.length !== 1 || url.searchParams.getAll(keys[0]).length !== 1) return;
    const key = keys[0];
    target = known[key + '=' + url.searchParams.get(key)];
    if (!target) return;
    url.searchParams.delete(key);
  }
  if (!target) return;
  const destination = new URL(target, url.origin);
  destination.search = url.searchParams.toString();
  destination.hash = url.hash;
  if (destination.href !== window.location.href) window.location.replace(destination.href);
})();
